export const apiUrl = process.env.REACT_APP_API_URL;
export const commit = process.env.REACT_APP_COMMIT;

(window as any).__MATCHJOB__ = { commit };
